import EnquirySliderLogin from './EnquirySliderLogin.component';

export default EnquirySliderLogin;